<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import DocumentCard from '../DocumentCard/DocumentCard.vue';

const emit = defineEmits(['create']);

const onClick = () => {
  emit('create');
};

// Sample data for the empty state preview (non-interactive backdrop)
const sampleDocuments = [
  {
    id: 1,
    title: 'Master service agreement',
    documentType: 'contract',
    status: 'in_review',
    partyName: 'Acme Corporation',
    dueDate: '2026-08-15',
    owner: { name: 'Sales Team' },
    nextStatuses: [],
    currentVersion: { id: 11, versionNumber: 2, filename: 'msa-v2.pdf' },
  },
  {
    id: 2,
    title: 'Identity verification',
    documentType: 'identity_document',
    status: 'requested',
    partyName: 'Sarah Johnson',
    dueDate: '2026-07-28',
    owner: { name: 'Jane Doe' },
    nextStatuses: [],
    currentVersion: null,
  },
  {
    id: 3,
    title: 'Annual support receipt',
    documentType: 'receipt',
    status: 'completed',
    partyName: 'Global Services Ltd.',
    dueDate: '2026-06-30',
    owner: { name: 'Mike Wilson' },
    nextStatuses: [],
    currentVersion: { id: 12, versionNumber: 1, filename: 'receipt.pdf' },
  },
];
</script>

<template>
  <EmptyStateLayout
    :title="$t('DOCUMENTS.EMPTY_STATE.TITLE')"
    :subtitle="$t('DOCUMENTS.EMPTY_STATE.DESCRIPTION')"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <DocumentCard v-for="document in sampleDocuments" :key="document.id" :document="document" />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('DOCUMENTS.EMPTY_STATE.ACTION')"
        icon="i-lucide-file-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
